/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowLargeUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2UlEQVR4nO2SSwrCMBCGCwpewIKepttSmsl0McyIR/MuCrrRhQsf2At4DyXSWA2ppSXu+kPIYib/N49E0aBQyvPFVCHvleZDShRHIZUSxYB8ApTH62guM6LZf8wxIMSMpTbna20uF3v3HtdX5ZrLoljOLcDEFPK5dyeueVYZWIDN6QVpMncBvSCf5krLzX3gAjpBiGgEWo7VQk++5YEH8C6sWrxCWfurT9MJoNwNxPweXw40AOpOZKOQV16AhSRJMm6Kww9AEMEAaBMMI2oTaN4plG1r4qCog54d6LoSDo3MAAAAAABJRU5ErkJggg==)
 */
export const ArrowLargeUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.7 3.3a1 1 0 0 0-1.4 0l-8 8a1 1 0 1 0 1.4 1.4L11 6.42V20a1 1 0 1 0 2 0V6.41l6.3 6.3a1 1 0 0 0 1.4-1.42l-8-8Z"
        className={colorClass}
      />
    </svg>
  );
};
